export enum SupportedLanguages {
  EN = 'en',
  IT = 'it',
}